"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const WarningCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-865.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(866.000000, 345.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(11.500000, 11.500000) rotate(-180.000000) translate(-11.500000, -11.500000) translate(0.000000, 0.000000)",
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M11.5,1.13686838e-13 C17.8512746,1.13686838e-13 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,1.13686838e-13 11.5,1.13686838e-13 Z M11.5,2 C6.25329488,2 2,6.25329488 2,11.5 C2,16.7467051 6.25329488,21 11.5,21 C16.7467051,21 21,16.7467051 21,11.5 C21,6.25329488 16.7467051,2 11.5,2 Z M12.2993352,10.4154712 L12.5020192,14.0992968 C12.5399646,14.8171589 12.5594,15.3324895 12.5594,15.6452883 C12.5594,16.0706048 12.4677758,16.4025316 12.2845273,16.6421941 C12.2178914,16.7288326 12.1336712,16.7828411 12.0513019,16.8379747 C12.02909,16.8548523 12.0115055,16.8773558 11.9865171,16.8919831 C11.8597239,16.9594937 11.7190483,17 11.5589373,17 C11.3997517,17 11.2600016,16.9594937 11.1322829,16.8919831 C11.10822,16.8773558 11.08971,16.8548523 11.0674981,16.8379747 C10.9851288,16.7828411 10.9018341,16.7288326 10.8342727,16.6421941 C10.6519497,16.4025316 10.5594,16.0706048 10.5594,15.6452883 C10.5594,15.3324895 10.5797609,14.8171589 10.6177063,14.0992968 L10.8194648,10.4154712 C10.8574102,9.93839662 10.9212695,9.58396624 11.0091918,9.35105485 C11.0980395,9.11701828 11.2553741,9 11.4830465,9 C11.5126624,9 11.6061376,9 11.6357535,9 C11.8634259,9 12.0207605,9.11701828 12.1096082,9.35105485 C12.198456,9.58396624 12.2613898,9.93839662 12.2993352,10.4154712 Z M11.6098396,8.22761042 C11.5922552,8.22761042 11.5274703,8.22761042 11.5080349,8.22761042 C11.2424171,8.22761042 11.0184467,8.12976306 10.8333472,7.93700376 C10.6510242,7.74228752 10.5594,7.50745386 10.5594,7.23054584 C10.5594,6.91449887 10.6547262,6.66792353 10.8463042,6.49277676 C11.0397332,6.31567304 11.2637036,6.22761042 11.5209919,6.22761042 C11.5339488,6.22761042 11.5459803,6.23445973 11.5598627,6.23445973 C11.5728197,6.23445973 11.5839257,6.22761042 11.5978081,6.22761042 C11.8541709,6.22761042 12.0781413,6.31567304 12.2715703,6.49277676 C12.4631483,6.66792353 12.5594,6.91449887 12.5594,7.23054584 C12.5594,7.50745386 12.4668503,7.74228752 12.2845273,7.93700376 C12.1003533,8.12976306 11.8754574,8.22761042 11.6098396,8.22761042 Z"
            })
          })
        })
      })
    })
  })]
});

WarningCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = WarningCircleIcon;
exports.default = _default;